//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PwrReset',
  inject: ['bus'],
  props: {
    resetText: {
      type: String,
      default: 'Submit',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },
};
